import type { CSSProperties, RefObject } from "react";
import { Ccontainer } from "../Ccontainer";
import { Cportal } from "../Cportal";
import { ColorType } from "@/theme/colors";
import { ContainerPreset } from "@/constants/componentPresets";
import { pxToRem } from "@/theme/spacing";
import type { CdropdownAlign, CdropdownOption } from "./Cdropdown.types";
import { DropdownOptionsList } from "./DropdownOptionsList";
import { buildAmbientGlowStyle, buildDropdownContainerStyle, buildDropdownWrapperStyle, buildTopAccentStyle, } from "./dropdown-surface-styles";
import { resolveDropdownTransformOrigin } from "./dropdown-transform-origin";
import { dataEl, type DataElScope } from "@/utils/dataEl";
const UPWARDS_VALUE = "upwards";
const DOWNWARDS_VALUE = "downwards";
export interface DropdownSurfaceProps {
    dataElScope: DataElScope;
    align: CdropdownAlign;
    options: CdropdownOption[];
    selectedKey: string | null;
    hoveredIndex: number | null;
    effectiveActiveIndex: number | null;
    isAnimating: boolean;
    isClosing: boolean;
    opensUpwards: boolean;
    dropdownListStyle: CSSProperties;
    optionsWrapperStyle: CSSProperties;
    optionsViewportStyle: CSSProperties;
    optionsViewportHeight: number | null;
    maxHeight: number | undefined;
    resolvedScrollFadeSize: number;
    scrollVerticalFadeTopSize: number | undefined;
    scrollVerticalFadeBottomSize: number | undefined;
    scrollVerticalFadeMiddleOpacity: number | undefined;
    optionsContainerRef: RefObject<HTMLDivElement | null>;
    optionsContentRef: RefObject<HTMLDivElement | null>;
    onDropdownRef: (node: HTMLDivElement | null) => void;
    onOptionElementRef: (input: {
        index: number;
        element: HTMLDivElement | null;
    }) => void;
    onOptionMouseEnter: (input: {
        index: number;
        isDisabled: boolean;
    }) => void;
    onOptionMouseLeave: () => void;
    onOptionClick: (option: CdropdownOption) => void;
}
export function DropdownSurface({ dataElScope, align, options, selectedKey, hoveredIndex, effectiveActiveIndex, isAnimating, isClosing, opensUpwards, dropdownListStyle, optionsWrapperStyle, optionsViewportStyle, optionsViewportHeight, maxHeight, resolvedScrollFadeSize, scrollVerticalFadeTopSize, scrollVerticalFadeBottomSize, scrollVerticalFadeMiddleOpacity, optionsContainerRef, optionsContentRef, onDropdownRef, onOptionElementRef, onOptionMouseEnter, onOptionMouseLeave, onOptionClick, }: DropdownSurfaceProps) {
    return (
    <Cportal>
      <div data-el={dataEl(dataElScope, "Surface/Root")} ref={onDropdownRef} style={buildDropdownWrapperStyle(dropdownListStyle)}>
        <div data-el={dataEl(dataElScope, "Surface/AmbientGlow")} style={buildAmbientGlowStyle({ isAnimating, isClosing })}/>

        <Ccontainer preset={ContainerPreset.Default} radius={32} backgroundColor={ColorType.Black} backgroundOpacity={0.85} borderColor={ColorType.Accent} borderOpacity={0.3} backdropBlur={24} padding={pxToRem(16)} boxShadow="rgba(0, 0, 0, 0.4) 0px 5px 20px 5px, rgba(102, 254, 193, 0.1) 0px 0px 0px 1px inset, rgba(255, 255, 255, 0.05) 0px 2px 4px 0px inset" display="flex" flexDirection="column" gap={8} style={{
            ...buildDropdownContainerStyle({
                isAnimating,
                isClosing,
                opensUpwards,
            }),
            transformOrigin: resolveDropdownTransformOrigin({
                align,
                opensUpwards,
            }),
        }}>
          <div data-el={dataEl(dataElScope, "Surface/TopAccent")} style={buildTopAccentStyle({
            isAnimating,
            isClosing,
            opensUpwards,
        })}/>

          <DropdownOptionsList dataElScope={dataElScope} options={options} selectedKey={selectedKey} hoveredIndex={hoveredIndex} effectiveActiveIndex={effectiveActiveIndex} isAnimating={isAnimating} isClosing={isClosing} optionsWrapperStyle={optionsWrapperStyle} optionsViewportStyle={optionsViewportStyle} optionsViewportHeight={optionsViewportHeight} maxHeight={maxHeight} resolvedScrollFadeSize={resolvedScrollFadeSize} scrollVerticalFadeTopSize={scrollVerticalFadeTopSize} scrollVerticalFadeBottomSize={scrollVerticalFadeBottomSize} scrollVerticalFadeMiddleOpacity={scrollVerticalFadeMiddleOpacity} optionsContainerRef={optionsContainerRef} optionsContentRef={optionsContentRef} onOptionElementRef={onOptionElementRef} onOptionMouseEnter={onOptionMouseEnter} onOptionMouseLeave={onOptionMouseLeave} onOptionClick={onOptionClick}/>
        </Ccontainer>
      </div>
    </Cportal>
    );
}
